import React, { useEffect, useState } from "react";
import emailjs from "@emailjs/browser";
import "./EnquiryPopup.css";

const EnquiryPopup = ({ onClose }) => {
  const [enquiry, setEnquiry] = useState({
    // Student
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    dob: "",
    religion: "",
    community: "",
    aadhar: "",
    nationality: "",
    gradeApplyingFor: "",
    currentClass: "",
    currentSchool: "",
    previousSchoolBoard: "",
    schoolTransportRequired: "",
    secondLanguagePreference: "",
    thirdLanguagePreference: "",

    // Parents
    fatherName: "",
    fatherContact: "",
    fatherProfession: "",
    fatherEmail: "",
    motherName: "",
    motherContact: "",
    motherProfession: "",
    motherEmail: "",

    // Others
    medicalHistory: "",
    expectation1: "",
    expectation2: "",
    residentialAddress: "",
    correspondenceAddress: "",
    heardFrom: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  /* Close popup on ESC */
  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEnquiry((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await emailjs.send(
        "service_6xgva7r", // Service ID
        "template_64lq45l", // Template ID (Enquiry)
        enquiry, // Enquiry data
        "uymgOEThqyWnQ1j2g" // Public Key
      );

      alert("Thank you! Our admissions team will contact you shortly.");

      // Reset form after success
      setEnquiry({
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        dob: "",
        religion: "",
        community: "",
        aadhar: "",
        nationality: "",
        gradeApplyingFor: "",
        currentClass: "",
        currentSchool: "",
        previousSchoolBoard: "",
        schoolTransportRequired: "",
        secondLanguagePreference: "",
        thirdLanguagePreference: "",

        fatherName: "",
        fatherContact: "",
        fatherProfession: "",
        fatherEmail: "",
        motherName: "",
        motherContact: "",
        motherProfession: "",
        motherEmail: "",

        medicalHistory: "",
        expectation1: "",
        expectation2: "",
        residentialAddress: "",
        correspondenceAddress: "",
        heardFrom: "",
      });

      onClose();
    } catch (error) {
      console.error("EmailJS Error (Popup Enquiry):", error);
      alert("Failed to submit enquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="popup-backdrop" onClick={onClose}>
      <div className="popup-card large" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>
          ✕
        </button>

        <h2 className="reveal-text">Admission Enquiry</h2>
        <p className="popup-sub">
          Please share the details below. Our admissions team will guide you further.
        </p>

        <form className="popup-form" onSubmit={handleSubmit}>
          {/* STUDENT DETAILS */}
          <h4 className="popup-section-title">Student Details</h4>

          <div className="popup-grid">
            <input
              name="firstName"
              placeholder="First Name*"
              required
              value={enquiry.firstName}
              onChange={handleChange}
            />
            <input
              name="middleName"
              placeholder="Middle Name"
              value={enquiry.middleName}
              onChange={handleChange}
            />
            <input
              name="lastName"
              placeholder="Last Name*"
              required
              value={enquiry.lastName}
              onChange={handleChange}
            />

            <select name="gender" required value={enquiry.gender} onChange={handleChange}>
              <option value="">Gender*</option>
              <option>Male</option>
              <option>Female</option>
              <option>Others</option>
            </select>

            <input type="date" name="dob" required value={enquiry.dob} onChange={handleChange} />

            <select
              name="religion"
              required
              value={enquiry.religion}
              onChange={handleChange}
            >
              <option value="">Religion*</option>
              <option>Hindu</option>
              <option>Muslim</option>
              <option>Christian</option>
              <option>Others</option>
            </select>

            <select
              name="community"
              required
              value={enquiry.community}
              onChange={handleChange}
            >
              <option value="">Community*</option>
              <option>SC</option>
              <option>ST</option>
              <option>OBC</option>
              <option>Others</option>
            </select>

            <input
              name="aadhar"
              placeholder="Aadhaar Number"
              maxLength={12}
              value={enquiry.aadhar}
              onChange={handleChange}
            />
            <input
              name="nationality"
              placeholder="Nationality*"
              required
              value={enquiry.nationality}
              onChange={handleChange}
            />

            <input
              name="gradeApplyingFor"
              placeholder="Grade Applying For*"
              required
              value={enquiry.gradeApplyingFor}
              onChange={handleChange}
            />
            <input
              name="currentClass"
              placeholder="Current Class"
              value={enquiry.currentClass}
              onChange={handleChange}
            />
            <input
              name="currentSchool"
              placeholder="Current School"
              value={enquiry.currentSchool}
              onChange={handleChange}
            />
          </div>

          {/* PARENT DETAILS */}
          <h4 className="popup-section-title">Parent Details</h4>

          <div className="popup-grid">
            <input
              name="fatherName"
              placeholder="Father Name"
              value={enquiry.fatherName}
              onChange={handleChange}
            />
            <input
              name="fatherContact"
              placeholder="Father Contact"
              value={enquiry.fatherContact}
              onChange={handleChange}
            />
            <input
              name="fatherProfession"
              placeholder="Father Profession"
              value={enquiry.fatherProfession}
              onChange={handleChange}
            />
            <input
              type="email"
              name="fatherEmail"
              placeholder="Father Email"
              value={enquiry.fatherEmail}
              onChange={handleChange}
            />

            <input
              name="motherName"
              placeholder="Mother Name"
              value={enquiry.motherName}
              onChange={handleChange}
            />
            <input
              name="motherContact"
              placeholder="Mother Contact"
              value={enquiry.motherContact}
              onChange={handleChange}
            />
            <input
              name="motherProfession"
              placeholder="Mother Profession"
              value={enquiry.motherProfession}
              onChange={handleChange}
            />
            <input
              type="email"
              name="motherEmail"
              placeholder="Mother Email"
              value={enquiry.motherEmail}
              onChange={handleChange}
            />
          </div>

          {/* ADDITIONAL INFO */}
          <h4 className="popup-section-title">Additional Information</h4>

          <textarea
            name="medicalHistory"
            rows="2"
            placeholder="Medical history (if any)"
            value={enquiry.medicalHistory}
            onChange={handleChange}
          />

          <input
            name="expectation1"
            placeholder="Expectation from the school"
            value={enquiry.expectation1}
            onChange={handleChange}
          />

          <textarea
            name="residentialAddress"
            rows="2"
            placeholder="Residential Address"
            value={enquiry.residentialAddress}
            onChange={handleChange}
          />

          <select name="heardFrom" value={enquiry.heardFrom} onChange={handleChange}>
            <option value="">How did you hear about us?</option>
            <option>Website</option>
            <option>Reference</option>
            <option>Newspaper</option>
            <option>Pamphlet</option>
            <option>Hoarding</option>
            <option>Others</option>
          </select>

          <button type="submit" className="popup-submit" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit Enquiry"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnquiryPopup;
